//
//
//
//
//
//
//

import About from './_components/About';
import Contact from './_components/Contact';

export default {
  name: 'AboutUs',
  components: {
    About,
    Contact,
  },
  head() {
    return {
      title: 'STEP1NE - 台灣頂尖人力資源顧問 | 專業招募與職涯發展',
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: '發現STEP1NE：頂級人力資源服務，打造職涯新高峰',
        },
        {
          hid: 'description',
          name: 'description',
          content:
            'STEP1NE，台灣頂尖的人力資源顧問公司，提供專業的人事服務、職業媒合，以及客製化的職涯解決方案，幫助個人和企業共創職業高峰。',
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content:
            'STEP1NE，台灣頂尖的人力資源顧問公司，提供專業的人事服務、職業媒合，以及客製化的職涯解決方案，幫助個人和企業共創職業高峰。',
        },
      ],
    };
  },
};
